import React from 'react';
import { Modal, Input, Form, Select, Checkbox,Tabs,Button} from 'antd';

import DetalleDestinoModal from './FormModal/DetalleDestinoModal';
import dialog from "../../../common/utility/dialog";


const { Option } = Select;
const { TabPane } = Tabs;

class FormModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    cuentaContableCustomValidation = (rule, value, callback) => {
        var longitud = this.props.form.getFieldValue('longitud');
        var cuentaContableLongitud = this.props.form.getFieldValue('cuentaContable').length;

        if (longitud > 0 && longitud !== cuentaContableLongitud) {
            callback('La longitud de ser de ' + longitud + ' caracteres.');
        }

        callback();
    }

    handleCancel = () => {
        this.props.onClose();
        this.props.form.resetFields();
    }

    handleOk = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const form = {
                    id: values.id,
                    idTipoPlan: values.idTipoPlan.key,
                    idTipoAnalisis: values.estadoAnalisis ? values.idTipoAnalisis.key : 0,
                    nombre: values.nombre,
                    cuentaContable: values.cuentaContable,
                    idGrado: values.idGrado.key,
                    idColumnaBalance: values.idColumnaBalance.key,
                    idMoneda: values.idMoneda.key,
                    idTipoCambio: values.idTipoCambio.key,
                    estadoAnalisis: values.estadoAnalisis,
                    estadoProyecto: values.estadoProyecto,
                    estadoAjuste:values.estadoAjuste,
                    CuentaDetalles: this.fetchDetalle(values),

                }

                var totalPorcentaje = parseFloat(form.CuentaDetalles.reduce((a, b) => a + (b["porcentaje"] || 0), 0));
                 if(form.CuentaDetalles.length!=0){
                    if(totalPorcentaje==100){
                        this.props.onSave(form, this.props.form);
                    }else{
                        dialog.error("la suma de porcentaje debe ser 100%");
    
                    }

                 }else{
                    this.props.onSave(form, this.props.form);

                 }
           
            }
        });
    }

    fetchDetalle = (values) => {
        var result = [];
        var keys = [];
        var obj = Object.assign({}, values.idDebe);
    
        for (var [key] of Object.entries(obj)) {
          keys.push(key);
        }
        keys.forEach((key) => {
          result.push({
            idDebe: values.idDebe[key].key,
            idHaber: values.idHaber[key].key,
            porcentaje: parseFloat(values.porcentaje[key]),
            flagInterno: true,
          });
        });
    
        return result;
      };

      

    render() {
        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;

        getFieldDecorator('id', { initialValue: this.props.formValues.id });
        getFieldDecorator('longitud', { initialValue: 0 });
        getFieldDecorator('arrDetalle', { initialValue: this.props.formValues.listaComprobanteDetalle });

        return (
            <Modal
                title={(this.props.formValues.id === 0 ? "Registrar" : "Modificar") + " Plan de Cuenta"}
                visible={this.props.visible}
                cancelText={"Cancelar"}
                okText={"Guardar"}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                style={{ top: 30 }}
                width="900px"
            >
                <Form>
                    <div className="row">
                    <div className="col-md-4 form-group">
                            <Form.Item label="Tipo de Cuenta">
                                {getFieldDecorator('idTipoPlan', {
                                    initialValue: this.props.formValues.idTipoPlan > 0 ?
                                        { key: this.props.formValues.idTipoPlan } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Tipo Cuenta"}
                                        optionFilterProp="children"
                                 
                                    >
                                        {this.props.formValues.tipoCuenta.map(item => (
                                            <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-4 form-group">
                            <Form.Item label="Columna Balance">
                                {getFieldDecorator('idColumnaBalance', {
                                    initialValue: this.props.formValues.idColumnaBalance > 0 ?
                                        { key: this.props.formValues.idColumnaBalance } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Columna Balance"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.columnasBalance.map(item => (
                                            <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-4 form-group">
                            <Form.Item label="Grado">
                                {getFieldDecorator('idGrado', {
                                    initialValue: this.props.formValues.idGrado > 0 ?
                                        { key: this.props.formValues.idGrado } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Grado"}
                                        optionFilterProp="children"
                                        onChange={(option, item) => {
                                            this.props.form.setFieldsValue({ longitud: item.props.data }, () => {
                                                this.props.form.validateFields(["cuentaContable"]);
                                            });
                                        }}
                                    >
                                        {this.props.formValues.grados.map(item => (
                                            <Option key={item.id} value={item.id} data={item.longitud}>{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 form-group">
                            <Form.Item label="Cuenta Contable">
                                {getFieldDecorator('cuentaContable', {
                                    initialValue: this.props.formValues.cuentaContable,
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Campo obligatorio.',
                                            whitespace: true
                                        },
                                        {
                                            validator: this.cuentaContableCustomValidation
                                        }
                                    ]
                                })(
                                    <Input
                                        placeholder="Ingresar Cuenta Contable"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>

                        <div className="col-md-4 form-group">
                            <Form.Item label="Moneda">
                                {getFieldDecorator('idMoneda', {
                                    initialValue: this.props.formValues.idMoneda > 0 ?
                                        { key: this.props.formValues.idMoneda } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Moneda"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.monedas.map(item => (
                                            <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-2 form-group">
                            <Form.Item label="Tipo de Cambio">
                                {getFieldDecorator('idTipoCambio', {
                                    initialValue: this.props.formValues.idTipoCambio > 0 ?
                                        { key: this.props.formValues.idTipoCambio } : undefined,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                    }]
                                })(
                                    <Select showSearch labelInValue
                                        placeholder={"Seleccione Tipo de Cambio"}
                                        optionFilterProp="children"
                                    >
                                        {this.props.formValues.tiposCambio.map(item => (
                                            <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        </div>
                        <div className="col-md-1 form-group">
                            <Form.Item label="Ajuste TC">
                                {getFieldDecorator('estadoAjuste', {
                                    initialValue: this.props.formValues.estadoAjuste,
                                    valuePropName: 'checked'
                                })(<Checkbox></Checkbox>)}
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                    <div className="col-md-6 form-group">
                            <Form.Item label="Descripción cuenta">
                                {getFieldDecorator('nombre', {
                                    initialValue: this.props.formValues.nombre,
                                    rules: [{
                                        required: true,
                                        message: 'Campo obligatorio.',
                                        whitespace: true
                                    }]
                                })(
                                    <Input
                                        placeholder="Ingresar nombre"
                                        autoComplete="off"
                                    />
                                )}
                            </Form.Item>
                        </div>
               
                        <div className="col-md-2 form-group">
                            <Form.Item label="Proyecto">
                                {getFieldDecorator('estadoProyecto', {
                                    initialValue: this.props.formValues.estadoProyecto,
                                    valuePropName: 'checked'
                                })(<Checkbox></Checkbox>)}
                            </Form.Item>
                        </div>

                        <div className="col-md-1 form-group">
                            <Form.Item label="Análisis">
                                {getFieldDecorator('estadoAnalisis', {
                                    initialValue: this.props.formValues.estadoAnalisis,
                                    valuePropName: 'checked'
                                })(<Checkbox onChange={(e) => e.target.checked?  this.props.form.setFieldsValue({ idTipoAnalisis: undefined }):null}></Checkbox>)}
                            </Form.Item>
                        </div>

                        {this.props.form.getFieldValue('estadoAnalisis') ?
                            <div className="col-md-3 form-group">
                                <Form.Item label="Tipo Analisis">
                                    {getFieldDecorator('idTipoAnalisis', {
                                        initialValue: this.props.formValues.idTipoAnalisis > 0 ?
                                            { key: this.props.formValues.idTipoAnalisis } : undefined,
                                        rules: [{
                                            required: true,
                                            message: 'Campo obligatorio.',
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Tipo Analisis"}
                                            optionFilterProp="children"
                                        >
                                            {this.props.formValues.tipoAnalisis.map(item => (
                                                <Option key={item.id} value={item.id} >{item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </Form.Item>
                            </div>
                            : null

                        }

              

               

                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs
                                activeKey={this.props.formValues.activeKey}
                                onChange={this.props.onChangeTab}
                          
                                tabBarExtraContent={
                                    <div className="custom-options">
                                    <Button
                                        icon="plus"
                                        type="primary"
                                        onClick={this.props.onAgregarDetalle}
                                    >
                                        Agregar
                                    </Button>
                                    </div>
                                }
                            >
                                <TabPane tab="Destino" key="1">
                                    <DetalleDestinoModal
                                      dataSource={this.props.formValues.listaComprobanteDetalle}
                                      debe={this.props.formValues.debe}
                                      haber={this.props.formValues.haber}
                                      onRemove={this.props.onRemoverDetalle}
                                      onGetFieldDecorator={getFieldDecorator}
                                      
                                    />
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}
export default Form.create()(FormModal)